import React, { useMemo } from "react";
import { motion } from "framer-motion";

/**
 * GoldParticles — bursts golden sparks radially outward.
 * Sits absolutely inside a positioned parent (like a confirmation card).
 */
export default function GoldParticles({ count = 18, spread = 180, size = 6 }) {
  const items = useMemo(() => Array.from({ length: count }).map((_, i) => {
    const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.4;
    const dist = spread * (0.55 + Math.random() * 0.5);
    return {
      id: i,
      x: Math.cos(angle) * dist,
      y: Math.sin(angle) * dist,
      d: 0.9 + Math.random() * 1.0,
      delay: Math.random() * 0.25,
      s: size * (0.55 + Math.random() * 0.9),
    };
  }), [count, spread, size]);

  return (
    <div className="absolute inset-0 pointer-events-none flex items-center justify-center" aria-hidden="true">
      {items.map((p) => (
        <motion.span
          key={p.id}
          initial={{ x: 0, y: 0, opacity: 0, scale: 0.4 }}
          animate={{
            x: p.x,
            y: p.y,
            opacity: [0, 1, 1, 0],
            scale: [0.4, 1, 1, 0.6],
          }}
          transition={{ duration: p.d, delay: p.delay, ease: [0.16, 1, 0.3, 1] }}
          className="absolute rounded-full"
          style={{
            width: p.s,
            height: p.s,
            background: "radial-gradient(circle, #F8FAFC 0%, #39D6FF 40%, rgba(57,214,255,0) 80%)",
            boxShadow: "0 0 12px rgba(57,214,255,0.7)",
          }}
        />
      ))}
      {/* Center flash */}
      <motion.span
        initial={{ scale: 0.2, opacity: 0.6 }}
        animate={{ scale: 3, opacity: 0 }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        className="absolute w-20 h-20 rounded-full"
        style={{
          background: "radial-gradient(circle, rgba(248,250,252,0.45) 0%, rgba(57,214,255,0) 70%)",
        }}
      />
    </div>
  );
}
